<template>
  <main class="main page-inside payment-result-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title big">Thank you for your purchase! You will receive all purchase details to your provided e-mail. In case of any questions, please contact us at support@{{ hostname }}</div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PaymentSuccessPage',
  props: [],
  inject: ['hostname'],
  components: {
  },
  data: function() {
    return {
      
    }
  },

  methods: {
    
  },
});
</script>